import { Component, OnInit, SecurityContext } from '@angular/core';
import { PopupService } from '../../shared/modal/popup.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ParamContext } from '../../shared/service/param.context';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { getUrl } from '../../shared/util/dev-util';
import { VariableService } from '../../shared/ontology/service/variable.service';
import { TranslateService } from '@ngx-translate/core';
import { UrlService } from '../../shared/service/url.service';

@Component({
    selector: 'jhi-variable-details-modal',
    template: `
        <div class="modal-header">
            <h5 class="modal-title"><span>{{title}}</span></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()">
            </button>
        </div>
        <div class="modal-body">
            <iframe width="100%" height="480" frameborder="0" [src]="url"></iframe>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="cancel()">
                <span jhiTranslate="ok"></span>
            </button>
        </div>

    `
})
export class VariableDetailsModalComponent {
    readonly url: SafeResourceUrl;
    title: string;

    constructor(private route: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private context: ParamContext,
                public activeModal: NgbActiveModal,
                private variableService: VariableService,
                private translateService: TranslateService,
                private urlService: UrlService
    ) {
        const variableId = this.route.snapshot.queryParamMap.get('variableId');
        const url = '/ibpworkbench/controller/jhipster#/variable-details?restartApplication' +
            '&cropName=' + this.context.cropName +
            '&programUUID=' + this.context.programUUID +
            '&variableId=' + variableId;
        const safeUrl = this.urlService.buildSafeUrl(getUrl(url));
        // Fall back to a blank page if the URL is not on the allowlist.
        this.url = safeUrl !== null
            ? this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl)
            : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');

        if (variableId) {
            this.variableService.getVariableById(Number(variableId)).toPromise().then((variableDetails) => {
                this.title = this.translateService.instant('ontology.variable-details.title',
                    { param: variableDetails.name });
            });
        }

        (<any>window).closeModal = () => {
            this.activeModal.dismiss();
        };
    }

    cancel() {
        this.activeModal.dismiss();
    }
}

@Component({
    selector: 'jhi-variable-details-popup',
    template: ''
})
export class VariableDetailsPopupComponent implements OnInit {

    constructor(private popupService: PopupService) {
    }

    ngOnInit(): void {
        const modal = this.popupService.open(VariableDetailsModalComponent as Component);
    }
}
